/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./index.less");

var _tool = require("../../../../utils/tool");

var _config = require("../../../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)("div", {
    className: "charge-tit"
}, void 0, "\u5B9E\u65F6\u6570\u636E\uFF1A");

var _ref2 = (0, _jsx3.default)("div", {
    className: "equipment-fault-tit"
}, void 0, "\u6545\u969C\u4FE1\u606F");

var _ref3 = (0, _jsx3.default)("li", {
    className: "equipment-fault-header"
}, void 0, (0, _jsx3.default)("span", {}, void 0, "\u5E8F\u53F7"), (0, _jsx3.default)("span", {}, void 0, "\u6545\u969C"), (0, _jsx3.default)("span", {}, void 0, "\u72B6\u6001"));

var _ref4 = (0, _jsx3.default)("li", {
    className: "equipment-fault-header"
}, void 0, (0, _jsx3.default)("span", {}, void 0, "\u5E8F\u53F7"), (0, _jsx3.default)("span", {}, void 0, "\u6545\u969C"), (0, _jsx3.default)("span", {}, void 0, "\u72B6\u6001"));

var Source = function (_Component) {
    (0, _inherits3.default)(Source, _Component);

    function Source() {
        (0, _classCallCheck3.default)(this, Source);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Source.__proto__ || (0, _getPrototypeOf2.default)(Source)).call(this));

        _this.state = {
            secondarys1: [],
            secondarys2: [],
            realTime: [{ sou: "源边1固件版本", val: "", key: 'src1FirmwareVersion' }, { sou: "源边2固件版本", val: "", key: 'src2FirmwareVersion' }, { sou: "充电模式", val: "", key: 'chargingModeNumber' }, { sou: "充电需求电压(v)", val: "", key: 'requireChargingVoltage' }, { sou: "充电需求电流(A)", val: "", key: 'requireChargingCurrent' }, { sou: "充电电压测量值(v)", val: "", key: 'chargingVoltageMeasurementValue' }, { sou: "充电电流测量值(A)", val: "", key: 'chargingCurrentMeasurementValue' }, { sou: "充电机当前温度(℃)", val: "", key: 'currentChargerTemperature' }]
        };
        return _this;
    }

    /*2019.8.22*/


    (0, _createClass3.default)(Source, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.handleGetList();
            this.handleFault1();
            this.handleFault2();
        }
    }, {
        key: "handleGetList",
        value: function handleGetList() {
            var _this2 = this;

            (0, _tool.http)(_config.apiJson.getCabinetSourceEdgeInfo, this.props || {}).then(function (res) {

                var result = res || {};
                _this2.state.realTime.forEach(function (item) {
                    if (item.key === 'chargingModeNumber') {
                        item.val = result[item.key] === 2 ? '恒流充电' : '恒压充电';
                    } else {
                        if (item.sou.indexOf('v') !== -1) {
                            item.val = result[item.key] / 10 || '--';
                        } else if (item.sou.indexOf('A') !== -1) {
                            item.val = result[item.key] / 100 || '--';
                        } else if (item.sou.indexOf('kwh') !== -1) {
                            item.val = result[item.key] / 10 || '--';
                        } else {
                            item.val = result[item.key] || result[item.key] == 0 ? result[item.key] : '--';
                        }
                    }
                });
                _this2.setState({
                    realTime: _this2.state.realTime
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
            });
        }

        // 故障列表

    }, {
        key: "handleFault1",
        value: function handleFault1() {
            var _this3 = this;

            (0, _tool.http)(_config.apiJson.getCabinetSource1FaultInfo, this.props || {}).then(function (res) {
                _this3.setState({
                    secondarys1: res || []
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
            });
        }
    }, {
        key: "handleFault2",
        value: function handleFault2() {
            var _this4 = this;

            (0, _tool.http)(_config.apiJson.getCabinetSource2FaultInfo, this.props || {}).then(function (res) {

                _this4.setState({
                    secondarys2: res || []
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? "" + res : res.errmsg;
            });
        }

        /*------------------------------*/

    }, {
        key: "render",
        value: function render() {
            return (0, _jsx3.default)("div", {
                className: "source"
            }, void 0, (0, _jsx3.default)("div", {
                className: "charge-realtime"
            }, void 0, _ref, (0, _jsx3.default)("div", {
                className: "charge-datas"
            }, void 0, this.state.realTime.map(function (res, i) {
                return (0, _jsx3.default)("div", {
                    className: "charge-xx"
                }, i, res.sou, "\uFF1A", res.val);
            }))), (0, _jsx3.default)("div", {
                className: "equipment-fault"
            }, void 0, _ref2, (0, _jsx3.default)("ul", {
                className: "equipment-fault-info "
            }, void 0, _ref3, this.state.secondarys1.map(function (res, i) {
                return (0, _jsx3.default)("li", {
                    className: "equipment-fault-footer"
                }, i, (0, _jsx3.default)("span", {}, void 0, i + 1, ". "), (0, _jsx3.default)("span", {}, void 0, _tool.filter.faultInfo(res.function), " "), (0, _jsx3.default)("span", {}, void 0, res.status === 0 ? '正常' : '异常'));
            })), (0, _jsx3.default)("ul", {
                className: "equipment-fault-info  "
            }, void 0, _ref4, this.state.secondarys2.map(function (res, i) {
                return (0, _jsx3.default)("li", {
                    className: "equipment-fault-footer"
                }, i, (0, _jsx3.default)("span", {}, void 0, i + 1, ". "), (0, _jsx3.default)("span", {}, void 0, _tool.filter.faultInfo(res.function), " "), (0, _jsx3.default)("span", {}, void 0, res.status === 0 ? '正常' : '异常'));
            }))));
        }
    }]);
    return Source;
}(_react.Component);

exports.default = Source;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/sbDevice/batteryInfo/sourceEdge/index.jsx
// module id = 1559
// module chunks = 0